// Text-only testimonials — NO image field by design.
export const testimonials = [
  {
    name: "Sailesh Bharwad",
    role: "Database Marketing Manager",
    location: "United States",
    testimonial:
      "Axor Technologies helped me understand how to approach the US job market and prepare myself professionally. The guidance felt personal, never generic.",
  },
  {
    name: "Kevin Dobariya",
    role: "Cybersecurity Specialist- Information Technology ",
    location: "United States",
    testimonial:
      "The interview preparation completely changed how I present myself. I walked into conversations with clarity and real confidence.",
  },
  {
    name: "Keyur Mangaroliya",
    role: "Cybersecurity Engineer ",
    location: "United States",
    testimonial:
      "As a graduate, I had no idea where to start. Axor gave me direction, structure and a plan that actually made sense for my goals.",
  },
  {
    name: "Eric Garrison",
    role: "Network Engineer",
    location: "United States",
    testimonial:
      "Working with Axor made it easier to connect with candidates who genuinely fit our teams. Their approach is thoughtful and human.",
  },
  {
    name: "Vaishnavi Purohit",
    role: "Business analyst",
    location: "United States",
    testimonial:
      "I was changing career paths and felt uncertain. Axor helped me reposition my experience and move forward with a clear next step.",
  },
];
